export default "__VITE_ASSET__s5Uz8NcC__"